var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.824 18.636c.248.236.55.364.894.364.722 0 1.282-.557 1.282-1.264 0-.353-.14-.675-.388-.92L3.071 9.488l7.541-7.304c.248-.246.388-.578.388-.921C11 .557 10.44 0 9.718 0c-.345 0-.646.129-.884.364L.452 8.504A1.33 1.33 0 0 0 0 9.5c0 .375.15.696.442.985z"
  })));
};
export default SvgChevronLeft;